import { RootStoreModule } from './root-store.module';
import * as RootStoreState from './root-state';
export { RootStoreState, RootStoreModule };
